<ng-container>
  <ng-container>
    <div>
      <div class="col-lg-12" *ngIf="!standalone">
        <div>
          <span
            class="d-flex justify-content-between align-items-center pt-2 pb-2 mb-2 globalborder-btm-header">
            <span class="col-auto">
              <h2 class="mb-0">PDF</h2>
            </span>
            <span class="col-auto">
              <span class="cross-border" (click)="closePdfStacker()"
                ><i class="pi pi-times"></i
              ></span>
            </span>
          </span>
        </div>
      </div>
      <ngx-extended-pdf-viewer
        [base64Src]="base64pdf"
        [textLayer]="true"
        [showHandToolButton]="true"
        [showPresentationModeButton]="true"
        [filenameForDownload]="fileNameToDownload"
        [height]="standalone ? '100vh' : '75vh'"></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
</ng-container>
